import { Injectable } from '@angular/core';
import { ICommonDropdownService } from '../ui-lib/common-dropdawn/typing/common-dropdown-service.interface';
import { Params } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { IPaginatedResponse } from '../typing/response.interface';
import { ILabelValue } from '../ui-lib/common-dropdawn/typing/label-value.interface';
import { LocationService } from './location.service';
import { ILocation } from '../typing/location.interface';

@Injectable({
    providedIn: 'root'
})
export class LocationSelectorService implements ICommonDropdownService {

    constructor(private locationService: LocationService) {
    }

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        return this.locationService.getList(query).pipe(map(response => this.transformData(response)));
    }

    transformData(paginatedResponse: IPaginatedResponse<ILocation>): IPaginatedResponse<ILabelValue> {
        const transformedData = paginatedResponse.data.map(location => ({
            label: location.address,
            value: location.id,
            tooltip: this.getTooltip(location),
        }));

        return {
            ...paginatedResponse,
            data: transformedData,
        } as IPaginatedResponse<ILabelValue>;
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        return this.locationService.getLocation(Number(optionValue)).pipe(
            filter(location => !!location),
            map(location => ({
                label: location.address as string,
                value: location.id as number,
                tooltip: '---',
            })),
        );
    }

    getTooltip(value: ILocation): string {
        return (value.address ? value.address : '') + (value.id ? '; id:' + value.id : '') ;
    }
}
